var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_done_1656248") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-267.000000, -38.000000)",
    fill: "#45C095",
    fillRule: "nonzero",
    stroke: "#45C095",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8586957,10.1576087 C19.8586957,15.75 15.4076087,20.3152174 9.92934783,20.3152174 C4.45108696,20.3152174 0,15.75 0,10.1576087 C0,4.56521739 4.45108696,0 9.92934783,0 C11.9836957,0 13.9695652,0.639130435 15.6586957,1.84891304 C15.8641304,1.98586957 15.9097826,2.2826087 15.7728261,2.48804348 C15.6358696,2.69347826 15.3391304,2.73913043 15.1336957,2.57934783 C13.6043478,1.50652174 11.801087,0.913043478 9.92934783,0.913043478 C4.95326087,0.913043478 0.913043478,5.0673913 0.913043478,10.1576087 C0.913043478,15.2478261 4.95326087,19.4021739 9.92934783,19.4021739 C14.9054348,19.4021739 18.9456522,15.2478261 18.9456522,10.1576087 C18.9456522,9.90652174 19.151087,9.70108696 19.4021739,9.70108696 C19.6532609,9.70108696 19.8586957,9.90652174 19.8586957,10.1576087 Z M20.8402174,2.35108696 C20.6576087,2.16847826 20.3608696,2.16847826 20.201087,2.35108696 L10.5,12.3032609 L6.36847826,8.0576087 C6.18586957,7.875 5.91195652,7.875 5.72934783,8.0576087 C5.54673913,8.24021739 5.54673913,8.51413043 5.72934783,8.69673913 L10.1804348,13.2619565 C10.2717391,13.3532609 10.3858696,13.398913 10.5,13.398913 C10.6141304,13.398913 10.751087,13.3532609 10.8195652,13.2619565 L20.8630435,3.01304348 C21.0228261,2.83043478 21.0228261,2.53369565 20.8402174,2.35108696 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ee43e1756402e616a61556bfaa383da6.svg";
export { ForwardRef as ReactComponent };